import React, { useEffect, useState } from "react";
import AllCards from "./Orderpages/AllCards";
import CardShimmer from "../Preloader/CardShimmer";
import { useSelector } from "react-redux";
import Search from "../form/Search";
import CalendarPopover from "../popup/CalendarPopover";

const Ordertab = ({ search, setSearch, start_date, end_date }) => {
  const { pagination, tabCounts = {} } = useSelector((state) => state.order);

  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    start_date: null,
    end_date: null,
  });

  const TABS = [
    { label: "All", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Delivered", value: "delivered" },
    { label: "Cancelled", value: "cancelled" },
  ];

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(t);
  }, [activeTab, search, start_date, end_date]);

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const clearDateFilter = () => {
    setDateRange({
      start_date: null,
      end_date: null,
    });
  };

  const renderShimmer = () => (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {Array(6)
        .fill(0)
        .map((_, i) => (
          <CardShimmer key={i} className="h-32" />
        ))}
    </div>
  );

  return (
    <section className="flex justify-start">
      <div className="w-full max-w-7xl flex flex-col gap-4">
        {/* TABS */}

        <div className="w-full mt-4">
          <div
            className=" flex items-center justify-center md:justify-evenly 
              gap-2 md:gap-6 p-2 
              border border-[#FF6943] rounded-full 
              md:border-0 
              md:border-b 
              md:border-[#FF7043] 
              md:rounded-none
              md:pb-3
               md:shadow-[0_2px_6px_rgba(0,0,0,0.04)]
            "
          >
            {TABS.map((tab) => (
              <button
                key={tab.value}
                onClick={() => {
                  setActiveTab(tab.value);
                  document.activeElement?.blur();
                }}
                className={`font-semibold text-[11px] md:text-sm px-4 py-2 rounded-full relative transition-all duration-200 ${
                  activeTab === tab.value
                    ? "bg-[#FF7043] text-white"
                    : "bg-white hover:text-[#FF7043]"
                }`}
              >
                {tab.label}

                {tabCounts[tab.value] ? (
                  <span
                    className={`absolute -top-2 -right-2 text-[10px] md:text-[10px] font-bold h-5 min-w-[1.25rem] px-2 flex justify-center items-center rounded-full border border-gray-100 
    ${
      activeTab === tab.value
        ? "bg-white text-black"
        : "bg-red-100 text-red-500"
    } whitespace-nowrap`}
                  >
                    {tabCounts[tab.value] || ""}
                  </span>
                ) : (
                  ""
                )}
              </button>
            ))}
          </div>
        </div>
        {/* SEARCH + FILTER */}
        <div className="flex   max-w-7xl justify-between items-center gap-4 mt-4">
          <Search
            searchValue={search}
            onSearch={(value) => setSearch(value)}
            extraClasses="w-full"
          />

          <div className="flex flex-row justify-between gap-4">
            <CalendarPopover
              value={dateRange}
              onApply={(range) => {
                setDateRange({
                  start_date: range?.start_date || null,
                  end_date: range?.end_date || null,
                });
              }}
            />
          </div>
        </div>

        <div className=" ">
          {dateRange.start_date && dateRange.end_date && (
            <div className="flex justify-between items-center gap-2 bg-red-50  text-orange-600 px-4 py-2 rounded-xl text-sm font-medium">
              <span>
                {formatDisplayDate(dateRange.start_date)} -{" "}
                {formatDisplayDate(dateRange.end_date)}
              </span>

              <button
                onClick={clearDateFilter}
                className="text-red-500 hover:text-red-700 text-lg leading-none"
              >
                ×
              </button>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="mt-4 relative min-h-[420px]">
          {/* ACTUAL CONTENT (always mounted) */}
          <div className={loading ? "opacity-40 pointer-events-none" : ""}>
            <AllCards
              filterStatus={activeTab}
              search={search}
              start_date={dateRange.start_date}
              end_date={dateRange.end_date}
            />
          </div>

          {/* SHIMMER OVERLAY */}
          {loading && (
            <div className="absolute inset-0 bg-white z-10">
              {renderShimmer()}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Ordertab;
